import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";

export default function Lable({ props, width }) {
  const [lableItem] = useState(Object.values(props));
  return (
    <Container>
      {lableItem.map((data, index) => {
        return (
          <Header myWidth={ Array.isArray(width) ? width[index] : width} key={index + 1}>
            {data}
          </Header>
        );
      })}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  padding: 0 2rem;
`;

const Header = styled.p`
  color: ${Theme.colorFontLabel};
  font-size: ${Theme.fontSiz};
  font-weight: ${Theme.fontWeigh};
  width: ${(props) => props.myWidth};
`;
